<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-25 09:59:16
 * @FilePath: /wemeet-admin-new/src/views/brand/enterpriseCategory.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div style="padding: 10px">
    <el-button plain type="info" @click="goBack()">返回</el-button>
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane label="机构信息" name="first">
        <EnterpriseList ref="EnterpriseList" />
      </el-tab-pane>
      <el-tab-pane label="类目分组" name="second">
        <CategoryList ref="CategoryList" />
      </el-tab-pane>
      <el-tab-pane label="筛选设置" name="third">
        <div style="padding-left: 10px">
          <h2>机构列表-筛选条件栏设置</h2>

          <el-radio-group v-model="radio">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-radio :label="true">使用筛选条件栏，用户访问机构列表时，可使用筛选条件，缩小查询范围。</el-radio>
              </el-col>
              <el-col :span="24" style="margin-top: 20px">
                <el-radio :label="false">不使用筛选条件栏，机构列表信息平铺显示。</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>

          <div style="margin-top: 20px">
            <el-button size="small" type="primary" @click="saveQueryConfig">保存</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { getBrandList, editBrandStatus, deleteBrand } from '@/api/brand'

  import { querySearchConfig, addOrUpdateSearchConfig } from '@/api/enterPriseApi'
  import { useRoute } from 'vue-router'
  import CategoryList from './categoryList.vue'
  export default defineComponent({
    name: 'Brand',
    components: {
      EnterpriseList: defineAsyncComponent(() => import('./enterpriseList.vue')),
      CategoryList,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          likeExhibitorName: '',
          pageNum: 1,
          pageSize: 10,
          meetingCode: route.query.meetingCode,
        },
        activeName: 'first',
        exportPosterRef: null,
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        upLoadRef: null,
        resultRef: null,
        productUploadRef: null,
        chooseVal: [],
        fullscreenLoading: false,
        dialogVisible: false,
        posterUrl: '',
        checkRow: {},
        radio: '3',
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: row.exhibitorCode,
            industryType: row.industryType,
            meetingType: state.queryForm.meetingType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.exhibitorCode) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            await deleteBrand({
              exhibitorCode: row.exhibitorCode,
              meetingCode: state.queryForm.meetingCode,
            })
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        state.queryForm.meetingCode = route.query.meetingCode
        state.queryForm.groupId = route.query.groupId
        const { data } = await getBrandList(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false

        const { data: configData } = await querySearchConfig({
          enterpriseGroupId: state.queryForm.groupId,
        })
        console.log(configData)

        state.radio = configData
      }

      const refreshActivatedData = () => {
        fetchData()
        proxy.$refs.EnterpriseList?.fetchData?.()
        proxy.$refs.CategoryList?.fetchData?.()
      }

      const saveQueryConfig = async () => {
        try {
          await addOrUpdateSearchConfig({
            enterpriseGroupId: state.queryForm.groupId,
            isSearch: state.radio,
          })
          proxy.$baseMessage('保存成功', 'success', 'vab-hey-message-success')
        } catch {
          proxy.$baseMessage('保存失败', 'error', 'vab-hey-message-error')
        }
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const shopStatusChange = async (row) => {
        try {
          let obj = {
            status: row.status,
            exhibitorCode: row.exhibitorCode,
          }
          await editBrandStatus(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
          console.log(e)
        }

        fetchData()
      }

      onMounted(() => {
        fetchData()
      })

      let isFirstActivated = true
      onActivated(() => {
        if (isFirstActivated) {
          isFirstActivated = false
          return
        }
        refreshActivatedData()
      })

      const goBack = () => {
        proxy.$router.go(-1)
      }

      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        shopStatusChange,
        handleConfig,
        Delete,
        Search,
        saveQueryConfig,
        Plus,
        goBack,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
